<template>
	<div class="flex">
		<div>
			<svg
					class="h-5 w-5 mr-2 mt-0.5"
					fill="none"
					stroke="currentColor"
					viewBox="0 0 24 24"
					xmlns="http://www.w3.org/2000/svg"
			>
				<path
						d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
						stroke-linecap="round"
						stroke-linejoin="round"
						stroke-width="2"
				/>
			</svg>
		</div>
		<div>
			{{ value.title }}
		</div>
	</div>
</template>

<script lang="ts" setup>
import {EventOptionValueInterface} from "@/js/interfaces/option"

defineProps<{
	value: EventOptionValueInterface
}>()
</script>
